<template>
    <PersonalAccountSearchForm
        v-model:contract-num="searchData.contractNum"
        v-model:start-date="searchData.start_date"
        v-model:end-date="searchData.end_date"
        :selects="searchSelects"
        :loading="isLoadingContractList"
        @change="onChangeContractNum"
        @change-start-date="onChangeStartDate"
        @change-end-date="onChangeEndDate"
        @search="searchContract"
    />
    <a-divider />
    <div class="personal_account_info">
        <div class="personal_account_info_left">
            <p>Всего договоров: <span>{{ pagination.total }}</span></p>
        </div>
        <div class="personal_account_info_right">
            <a-button @click="exportContracts">
                <img src="../../assets/images/downloadFile.svg" alt="">
                Выгрузить данные раздела
            </a-button>
            <a-button @click="getAllReports">
                <img src="../../assets/images/downloadFile.svg" alt="">
                Общая выгрузка данных (все разделы)
            </a-button>
        </div>
    </div>
    <a-divider />
    <div class="personal_account_table">
        <a-table
            :columns="contractColumns"
            :row-key="record => record.id"
            :data-source="contractList"
            :loading="isLoadingContractList"
            :row-class-name="rowClassName"
            :scroll="{ x: 'max-content' }"
            :pagination="pagination"
            @change="onChangePagination"
        >
            <template #bodyCell="{ column , record}">
                <template v-if="column.key === 'product'">
                    <div class="product_name_col">
                        <div class="product_name_line" :class="record.days_left !== null && record.days_left > 7 && record.days_left <= 30 ? 'product_name_line_warning' :record.days_left !== null &&  record.days_left <= 7 && record.days_left >= -1 ? 'product_name_line_error' : ''"></div>
                        <p v-if="record.days_left === null || record.days_left > 30 || record.days_left < -1">
                            {{ record.product }}
                        </p>
                        <a-tooltip v-if="record.days_left > 7 && record.days_left <= 30" color="#FFF3E7" overlay-class-name="contract_action_tooltip" style="width: 320px;" :overlayInnerStyle="{ width: '250px' }">
                            <template #title>
                                <div class="tooltip-content">
                                    <div class="contract_action_tooltip_warning">
                                        <img src="../../assets/images/warning_icon.svg" alt="icon" />
                                    </div>
                                    <div class="tooltip-content_text">
                                         <p>{{ record.expiration_message }}</p>
                                         <span>До окончания действия договора</span>
                                    </div>
                                </div>
                            </template>
                            <p> {{ record.product }}</p>
                        </a-tooltip>
                        <a-tooltip v-if="record.days_left !== null && record.days_left <= 7 && record.days_left > 0" color="#C00202">
                            <template #title>
                                <div class="tooltip-content">
                                    <div class="contract_action_tooltip_error">
                                        <img src="../../assets/images/error_document_icon.svg" alt="">
                                    </div>
                                     <div class="tooltip-content_text_error">
                                         <p>{{ record.expiration_message }}</p>
                                         <span>До окончания действия договора</span>
                                     </div>
                                 </div>
                            </template>
                            <p> {{ record.product }}</p>
                        </a-tooltip>
                         <a-tooltip v-if="record.days_left === -1" color="#C00202">
                            <template #title>
                                <div class="tooltip-content">
                                    <div class="contract_action_tooltip_error">
                                        <img src="../../assets/images/expired_icon.svg" alt="">
                                    </div>
                                     <div class="tooltip-content_text_error">
                                         <p>{{ record.expiration_message }}</p>
                                         <span>Ваш договор просрочен</span>
                                     </div>
                                 </div>
                            </template>
                            <p> {{ record.product }}</p>
                        </a-tooltip>
                        <a-tooltip v-if="record.days_left === 0" color="#C00202">
                            <template #title>
                                <div class="tooltip-content">
                                    <div class="contract_action_tooltip_error">
                                        <img src="../../assets/images/error_document_icon.svg" alt="">
                                    </div>
                                     <div class="tooltip-content_text_error">
                                        <p>{{ record.expiration_message }}</p>
                                        <span>Срок действия договора заканчивается сегодня</span>
                                     </div>
                                 </div>
                            </template>
                            <p> {{ record.product }}</p>
                        </a-tooltip>
                    </div>
                    
                </template>
                <template v-else-if="column.dataIndex === 'insurance_premium'">
                    <p style="text-align: center;">
                        {{record.insurance_premium ? `${record.insurance_premium}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' '): ''}}
                    </p>
                </template>
                <template v-else-if="column.dataIndex === 'action'">
                    <div class="contract_action">
                        <div class="contract_action_error" v-if="record.days_left === null || record.days_left > 30 || record.days_left < - 1"></div>
                        <a-tooltip v-if="record.days_left !== null && record.days_left > 7 && record.days_left <= 30" color="#FFF3E7" overlay-class-name="contract_action_tooltip" style="width: 320px;" :overlayInnerStyle="{ width: '250px' }">
                            <template #title>
                                <div class="tooltip-content">
                                    <div class="contract_action_tooltip_warning">
                                        <img src="../../assets/images/warning_icon.svg" alt="icon" />
                                    </div>
                                    <div class="tooltip-content_text">
                                         <p>{{ record.expiration_message }}</p>
                                         <span>До окончания действия договора</span>
                                    </div>
                                </div>
                            </template>
                            <div class="contract_action_warning">
                                <img src="../../assets/images/warning_icon.svg" alt="">
                            </div>
                        </a-tooltip>
                        <a-tooltip v-if="record.days_left !== null && record.days_left <= 7 && record.days_left > 0" color="#C00202">
                            <template #title>
                                <div class="tooltip-content">
                                    <div class="contract_action_tooltip_error">
                                        <img src="../../assets/images/error_document_icon.svg" alt="">
                                    </div>
                                    <div class="tooltip-content_text_error">
                                         <p>{{ record.expiration_message }}</p>
                                         <span>До окончания действия договора</span>
                                    </div>
                                   
                                </div>
                            </template>
                            <div class="contract_action_error">
                                <img src="../../assets/images/error_document_icon.svg" alt=""></img>
                            </div>
                        </a-tooltip>
                         <a-tooltip v-if="record.days_left !== null &&record.days_left === -1" color="#C00202">
                            <template #title>
                                <div class="tooltip-content">
                                    <div class="contract_action_tooltip_error">
                                        <img src="../../assets/images/expired_icon.svg" alt="">
                                    </div>
                                     <div class="tooltip-content_text_error">
                                          <p>{{ record.expiration_message }}</p>
                                          <span>Ваш договор просрочен</span>
                                     </div>
                                 </div>
                            </template>
                             <div class="contract_action_error">
                                <img src="../../assets/images/expired_icon.svg" alt="">
                            </div>
                        </a-tooltip>
                        <a-tooltip v-if="record.days_left !== null && record.days_left === 0" color="#C00202">
                            <template #title>
                                <div class="tooltip-content">
                                    <div class="contract_action_tooltip_error">
                                        <img src="../../assets/images/error_document_icon.svg" alt="">
                                    </div>
                                     <div class="tooltip-content_text_error">
                                         <p>{{ record.expiration_message }}</p>
                                         <span>Срок действия договора заканчивается сегодня</span>
                                     </div>
                                 </div>
                            </template>
                             <div class="contract_action_error">
                                <img src="../../assets/images/error_document_icon.svg" alt="">
                            </div>
                        </a-tooltip>
                        <button
                            v-if="record.file_path !== null" 
                            class="download_btn" 
                            @click="downloadFile(record)"
                        >
                            <download-outlined />
                            Скачать
                        </button>
                        <button class="open_btn" @click="openContractModal(record)">
                            Открыть
                        </button>

                    </div>
                </template>

            </template>
        </a-table>
    </div>
    <ContractModal :openedContract="openedContract" :open="isOpenContractModal" @close="isOpenContractModal = !isOpenContractModal"/>
</template>

<script>
import { Tabs, Input, DatePicker, Divider, Button, Spin, Table, Select, ConfigProvider, Tooltip} from 'ant-design-vue'
import ruRu from 'ant-design-vue/es/locale/ru_RU'
import {SearchOutlined, CalendarOutlined, DownloadOutlined} from '@ant-design/icons-vue'
import axios from 'axios';
import { useToast } from 'vue-toastification'
import store from '@/store'
import dayjs from 'dayjs';
import moment from 'moment';
import 'moment/locale/ru';
import 'dayjs/locale/ru';
import router from "@/router";
import ContractModal from './ContractModal.vue';
import PersonalAccountSearchForm from './PersonalAccountSearchForm.vue';
dayjs.locale('ru');
moment.locale('ru');
const toaster = useToast();
const contractColumns = [
{
  title: 'Наименование продукта',
  dataIndex: 'product',
  key: 'product',
  width: '18%'
},
{
  title: 'Номер договора',
  dataIndex: 'number',
  key: 'number',
  width: '15%',
},
{
  title: 'Дата начала',
  dataIndex: 'start_date',
  key: 'start_date',
  width: '10%'
},
{
  title: 'Дата окончания',
  dataIndex: 'end_date',
  key: 'end_date',
  width: '10%'
},
{
  title: 'Статус',
  dataIndex: 'status',
  key: 'status',
  width: '10%'
},
{
  title: 'Страховая премия',
  dataIndex: 'insurance_premium',
  key: 'insurance_premium',
  width: '10%'
},
{
  title: '',
  dataIndex: 'action',
  key: 'action',
  width: '25%'
},
];
const statusList = [
    {
        value: 'Действующий',
        label: "Действующий",
    },
    {
        value: 'Недействующий',
        label: "Недействующий",
    }
]
export default {
    props: {
        selectedCompanyId: {
            type: Number,
            default: null
        }
    },
    components: { 
        AInput: Input, 
        ADatePicker: DatePicker, 
        ADivider: Divider, 
        AButton: Button,
        ASpin: Spin, 
        ATabPane: Tabs.TabPane,
        ATable: Table,
        SearchOutlined,
        CalendarOutlined,
        DownloadOutlined,
        ASelect: Select,
        AConfigProvider: ConfigProvider,
        ATooltip: Tooltip,
        ContractModal,
        PersonalAccountSearchForm
    },
    data() {
        return {
            ruRu,
            user: store.getters['auth/getUser'],
            activeKey: 'contracts',
            searchData: {
              search: null,
              type_id: 1,
              product: null,
              start_date: null,
              end_date: null,
              status: null
            },
            contractColumns,
            contractList: [],
            isLoadingContractList: false,
            productTypeList: [],
            contractTypeList: [],
            isLoadingContractsObjectsList: false,
            isOpenContractModal: false,
            openedContract: null,
            statusList,
            pagination: {
                page: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
            }
        }
    }, 
    mounted() { 
        if(localStorage.getItem("auth_token")){
           axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("auth_token")}`
      }
      this.isLoadingContractList = true
      if(this.selectedCompanyId){
        this.pagination.page = 1;
        this.pagination.pageSize = 10;
        this.getProductList()
      }
    //   this.isLoadingContractList = true
    //   this.getProductList()
    },
    computed: {
        searchSelects(){
            return [
                {
                    key: 'type_id',
                    value: this.searchData.type_id,
                    placeholder: 'Выберите тип продукта',
                    options: this.productTypeList,
                    onUpdate: (value) => { this.searchData.type_id = value },
                    onChange: this.onChangeProductType,
                },
                {
                    key: 'product',
                    value: this.searchData.product,
                    placeholder: 'Выберите тип продукта',
                    options: this.contractTypeList,
                    onUpdate: (value) => { this.searchData.product = value },
                    onChange: this.onChangeContractType,
                },
                {
                    key: 'status',
                    value: this.searchData.status,
                    placeholder: 'Выберите статус',
                    options: this.statusList,
                    onUpdate: (value) => { this.searchData.status = value },
                    onChange: this.onChangeStatus,
                },
            ]
        }
    },
    methods: {
        onChangePagination(pagination){
            this.pagination = {...pagination, page: pagination.current};
            this.getContracts({...this.searchData, start_date: this.searchData.start_date? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY'): null});
        },
      async getContracts(data){
          const { page, pageSize } = this.pagination;
          await axios.get(`/V1/my-contracts?company_id=${this.selectedCompanyId}&page=${page}&per_page=${pageSize}`, {params: data}).then(res => {
              this.contractList = res.data.data.contracts;
              this.isLoadingContractList = false
              this.pagination.total = res.data.meta.total;
          }).catch(error => {
              let message;
              if (axios.isAxiosError(error) && error.response) {
                  message = error.response.data.message;
              } else {
                  message = String(error);
              }
              if(message.length === 0){
                message = 'Произошла ошибка при загрузке данных';
              }
              toaster.error(message, {
                  position: "top-right"
              })
          })
      },
      rowClassName(record, index){
        if(record.days_left !== null && record.days_left > 7 && record.days_left <= 30){
            return 'contract_action-row-warning'
        }
        if (record.days_left !== null && record.days_left <= 7 && record.days_left >= -1) {
            return 'contract_action-row-error'
        }
        return ''
    },
      async getProductList(){
        this.isLoadingProductList = true
        this.isLoadingContractList = true
          await axios.get(`/V1/my-contracts/type-products?company_id=${this.selectedCompanyId}`).then(res => {
              this.productTypeList = res.data.data.types.map(item => {
                  return {
                      label: item.label,
                      value: item.id,
                      children: item.products.map(product => {
                          return {
                              label: product,
                              value: product,
                          }
                      })
                  }
              });
              this.contractTypeList =  res.data.data.types.filter(item => item.id === 1)[0].products.map(item => {
                  return {
                      label: item,
                      value: item
                  }
              })
              if(this.contractTypeList.length === 1){
                  this.searchData.product = this.contractTypeList[0].value
              }
              this.getContracts({...this.searchData, start_date: this.searchData.start_date? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY'): null})
          }).catch(error => {
              let message;
              if (axios.isAxiosError(error) && error.response) {
                  message = error.response.data.message;
              } else {
                  message = String(error);
              }
              if(message.length === 0){
                message = 'Произошла ошибка при загрузке данных';
              }
              toaster.error(message, {
                  position: "top-right"
              })
              if(error.status === 401){
                  store.dispatch('auth/logoutTokenUnactive')
                  router.push('/')
              }
              
          })
      },
      onChangeContractNum(e){
          this.searchData.search = e.target.value
      },
      onChangeProductType(e){
          this.searchData.product_type = e
      },
      onChangeContractType(e){
          this.searchData.product = e
      },
      onChangeStartDate(e){
          this.searchData.start_date = e
      },
      onChangeEndDate(e){
          this.searchData.end_date = e
      },
      onChangeStatus(e){
          this.searchData.status = e
      },
      async searchContract(){
          try{
              this.isLoadingContractList = true
              this.pagination.page = 1;
              this.pagination.pageSize = 10;
            await this.getContracts({...this.searchData, start_date: this.searchData.start_date? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY'): null})
            this.isLoadingContractList = false
          }catch(error){
                this.isLoadingContractList = false
              let message;
              if (axios.isAxiosError(error) && error.response) {
                  message = error.response.data.message;
              } else {
                  message = String(error);
              }
              if(message.length === 0){
                message = 'Произошла ошибка при загрузке данных';
              }
              toaster.error(message, {
                  position: "top-right"
              })
          }finally{
              this.isLoadingContractList = false
          }
      },
      async downloadFile(record){
          try{
              const response = await axios.get(record.file_path, {
                  responseType: 'blob', 
              })
              const blob = new Blob([response.data])
              const downloadUrl = window.URL.createObjectURL(blob)

              const link = document.createElement('a')
              link.href = downloadUrl
              link.download = `${record.number}.pdf`
              document.body.appendChild(link)
              link.click()
              link.remove()

              window.URL.revokeObjectURL(downloadUrl)
          }catch(error){
              let message;
              if (axios.isAxiosError(error) && error.response) {
                  message = error.response.data.message;
              } else {
                  message = String(error);
              }
              if(message.length === 0){
                message = 'Произошла ошибка при загрузке данных';
              }
              toaster.error(message, {
                  position: "top-right"
              })
          }
      },
      openContractModal(record){
          this.isOpenContractModal = true
          this.openedContract = record
      },
      async getAllReports() {
          try{
            const startDate = this.searchData.start_date?.format("YYYY-MM-DD") ?? "";
            const endDate = this.searchData.end_date?.format("YYYY-MM-DD") ?? "";
              const response = await axios.get(`/V1/combined-export?company_id=${this.selectedCompanyId}&type_id=${1}&start_date=${startDate}&end_date=${endDate}`, {responseType: "blob"})
              const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                const url = window.URL.createObjectURL(blob);
                const disposition = response.headers['content-disposition'];
                let filename = 'reports.xlsx'; 
                if (disposition && disposition.includes('filename=')) {
                    const filenameRegex = /filename\*=utf-8''([^;]+)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = decodeURIComponent(matches[1]);
                    } else {
                        // Если нет filename*=, пробуем обычный filename=
                        const filenameSimpleRegex = /filename="?([^"]+)"?/;
                        const simpleMatches = filenameSimpleRegex.exec(disposition);
                        if (simpleMatches != null && simpleMatches[1]) {
                            filename = simpleMatches[1];
                        }
                    }
                }
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename); // Название файла
                document.body.appendChild(link);
                link.click();

                link.remove(); // Очистка
                window.URL.revokeObjectURL(url)
              
          }catch(error){
              let message;
              if (axios.isAxiosError(error) && error.response) {
                  message = error.response.data.message;
              } else {
                  message = String(error);
              }
              if(message.length === 0){
                message = 'Договор не найден';
              }
              toaster.error(message, {
                  position: "top-right"
              })
          }
      },
      async exportContracts(){
          try{
            const response = await axios.post(`/V1/my-contracts/export?company_id=${this.selectedCompanyId}`, {ids: this.contractList.map(contract => contract.id), contract_type: this.searchData.type_id}, {responseType: 'blob'})
            const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
            const url = window.URL.createObjectURL(blob);
            const disposition = response.headers['content-disposition'];
            let filename = 'contracts.xlsx'; 
            if (disposition && disposition.includes('filename=')) {
                const filenameRegex = /filename\*=utf-8''([^;]+)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = decodeURIComponent(matches[1]);
                } else {
                    // Если нет filename*=, пробуем обычный filename=
                    const filenameSimpleRegex = /filename="?([^"]+)"?/;
                    const simpleMatches = filenameSimpleRegex.exec(disposition);
                    if (simpleMatches != null && simpleMatches[1]) {
                        filename = simpleMatches[1];
                    }
                }
            }
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); // Название файла
            document.body.appendChild(link);
            link.click();

            link.remove(); // Очистка
            window.URL.revokeObjectURL(url)
          }catch(error){
              let message;
              if (axios.isAxiosError(error) && error.response) {
                  message = error.response.data.message;
              } else {
                  message = String(error);
              }
              if(message.length === 0){
                message = 'Произошла ошибка при загрузке данных';
              }
              toaster.error(message, {
                  position: "top-right"
              })
          }
      },
    },
    watch: {
        selectedCompanyId(newVal){
            if(newVal){
                this.pagination.page = 1;
                this.pagination.current = 1;
                this.getProductList()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @mixin fontStyle ($family,$style,$weight, $size, $lheight, $color) {
        font-family: $family;
        font-style: normal;
        font-weight: $weight;
        font-size: $size;
        line-height: $lheight;
        color: $color;
    }
    @mixin mobile {
        @media(min-width: 320px) and (max-width: 425px) {
            @content;
        }
    }
    @mixin tablet {
        @media(min-width: 425px) and (max-width: 767px) {
            @content;
        }
    }
    @mixin tablet-1024 {
        @media(min-width: 767px) and (max-width: 1024px) {
            @content;
        }
    }
    @mixin desktop {
        @media(min-width: 1024px) and (max-width: 1440px) {
            @content;
        }
    }
    @mixin desktop-max {
        @media(min-width: 1620px) and (max-width: 2560px) {
            @content;
        }
    }
    .col_p{
        margin-bottom: 0;
    }

    .ant-tooltip-inner {
        width: 320px;
    }

  .personal_account{
      padding: 30px 0;
      &_tabel{
        contain: layout
      }
      &_title{
          @include fontStyle(Roboto, normal, 500, 24px, 31px, #373737);
          text-align: center;
      }
      &_desc{
          @include fontStyle(Roboto, normal, 400, 22px, 31px, #909090);
          text-align: center;
          span{
              @include fontStyle(Roboto, normal, 400, 22px, 31px, #373737);
          }
      }
      &_info{
          @include fontStyle(Roboto, normal, 400, 24px, 31px, #373737);
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          row-gap: 15px;

          @media (max-width: 1024px) {
              flex-direction: column;
              align-items: flex-start;
          }

          &_left{
              width: 30%;
              @include fontStyle(Roboto, normal, 400, 20px, 31px, #373737);
              &_select{
                  width: 100%;
                  height: 50px;
              }

              @media (max-width: 1024px) {
                  width: 100%;
              }
          }
          &_right{
            display: flex;
            gap: 10px;
            flex-wrap: wrap;

            @media (max-width: 1024px) {
                width: 100%;
            }

              button{
                  @include fontStyle(Roboto, normal, 400, 16px, 31px, #373737);
                  padding: 4px 20px;
                  height: 55px;
                  display: flex;
                  align-items: center;
                  img{
                      width: 24px;
                      margin-right: 10px;
                  }

                  @media (max-width: 767px) {
                      flex: 1 1 100%;
                      height: auto;
                      min-height: 44px;
                      padding: 8px 14px;
                      font-size: 14px;
                      white-space: normal;
                      text-align: left;
                  }
              }
          }
      }
  }
  ::v-deep(.ant-table){
    contain: layout;
  }
  ::v-deep(.personal_account_info_left){
      .ant-select-selector{
          height: 50px;
          input{
              height: 50px;
          }
          .ant-select-selection-placeholder{
              height: 50px;
              display: flex;
              align-items: center;
          }
      }
  }
  ::v-deep(.personal_account_table){
      .ant-pagination{
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: flex-end;
          gap: 8px;
          row-gap: 10px;

          @media (max-width: 575px) {
              justify-content: center;
          }
      }
      .ant-pagination-options{
          margin-left: 0;

          @media (max-width: 575px) {
              order: 10;
              width: 100%;
              display: flex;
              justify-content: center;
          }
      }
  }
  .product_name_col{
      display: flex;
      gap: 10px;
      align-items: center;
  }
  .product_name_line{
      height: 38px;
      width: 5px;
      background: #007BFF;
      border-radius: 3px;
      &_warning{
          background: #FF8E0D;
      }
      &_error{
          background: #C00202;
      }
  }
  .download_btn, .open_btn{
      background-color: #fff;
      padding: 4px 8px;
      border: 2px solid #F5F5F5;
      border-radius: 4px;
      cursor: pointer;
  }
  .download_btn:hover, .open_btn:hover{
    color: #007BFF !important;
    text-decoration: underline !important;
    transition: .3s;
  }
  .download_btn{
      span{
          color: #007BFF;
          font-size: 18px;
      }
  }
  ::v-deep(.ant-tabs){
      .ant-tabs-nav-list{
          background: #F4F4F8 !important;
          border-radius: 8px;
          width: 100%;
          justify-content: space-between;
          padding: 15px 25px;
          .ant-tabs-tab-active{
              background: white !important;
          }
          .ant-tabs-tab{
              display: flex;
              justify-content: center;
              width: 30%;
              border: none;
              background: none;
              div{
                  font-size: 22px;
                  color: #373737;
                  border-radius: 8px;
                  padding: 7px 0;
              }
          }
      }
      .ant-tabs-content-holder{
          margin-top: 20px;
          .ant-tabs-tabpane{
              background: #F4F4F8 !important;
              border-radius: 8px;
          }
      }
  }
  .card-container p {
      margin: 0;
  }
  .card-container > .ant-tabs-card .ant-tabs-content {
      height: 120px;
      margin-top: -16px;
  }
  .card-container > .ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane {
      padding: 16px;
      background: #fff;
  }
  .card-container > .ant-tabs-card > .ant-tabs-nav::before {
      display: none;
  }
  .card-container > .ant-tabs-card .ant-tabs-tab,
  [data-theme='compact'] .card-container > .ant-tabs-card .ant-tabs-tab {
      background: transparent;
      border-color: transparent;
  }
  .card-container > .ant-tabs-card .ant-tabs-tab-active,
  [data-theme='compact'] .card-container > .ant-tabs-card .ant-tabs-tab-active {
      background: #fff;
      border-color: #fff;
  }
  #components-tabs-demo-card-top .code-box-demo {
      padding: 24px;
      overflow: hidden;
      background: #f5f5f5;
  }
  ::v-deep(.contract_action-row-warning){
   background: rgba(255, 142, 13, 0.102);
   &:hover{
        td{
            background: #FF8E0D1A !important;
        }
    }
  }
  ::v-deep(.contract_action-row-error){
    background: #C002021A;
    &:hover{
        td{
            background: #C002021A !important;
        }
    }
  }
  .tooltip-content{
    padding: 10px 0;
    display: flex;
    align-items: center;
    gap: 10px;
    p{
        margin-bottom: 0;
    }
    img{
        width: 24px;
    }
    &_text {
      p, span {
        color: #663C00;
      }
      p {
        font-weight: bold;
      }
      &_error{
        color: #fff;
      }
    }
  }
  .contract_action{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    &_warning{
        width: 40px;
        height: 40px;
        background: #FFF3E7;
        color: #fff;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            width: 100%;
        }
    }
    &_error{
        width: 40px;
        height: 40px;
        color: #fff;
        padding: 4px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 18px;     
    }
    &_tooltip_warning{
        width: 30px;
        height: 30px;
        background: #fff;
        padding: 4px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 18px;
    }
    &_tooltip_error{
        width: 30px;
        height: 30px;
        background: #fff;
        padding: 4px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 18px;
        color: #FF0000;
    }
  }
  ::v-deep(.ant-btn-default) {
		transition: .3s all;
		&:hover {
        background: #0059B9;
        color: #fff;
        img {
            filter: brightness(0) invert(1);
        }
    }
  }
</style>


       